import React, { useEffect, useState } from 'react'
import {user} from '../Join/Join';
import './Chat.css'
import socketIo from 'socket.io-client';
import Message from '../Message/Message';
import ReactScrollToBottom from 'react-scroll-to-bottom';

let socket;

// const ENDPOINT = 'localhost:5000';
const ENDPOINT = 'https://talkwithbuddy.herokuapp.com/'



const Chat = () => {
    const[id, setid] = useState("");
    const[messages, setMessages] = useState([]);

    const send = () => {
        const message = document.getElementById('chatInput').value;
        socket.emit('message', { message, id });
        
        document.getElementById('chatInput').value = "";

    }


console.log(messages)
useEffect(() => {
 socket = socketIo(ENDPOINT , {  transports: ['websocket'] });

socket.on('connect', () => {
    console.log('connected');
    setid(socket.id);
     
})
console.log(socket);
socket.emit('joined',{ user })

socket.on('welcome',(data) => {
    setMessages([...messages, data]);
    console.log(data.user, data.message);
    
})

socket.on('userjoined',(data) => {
    setMessages([...messages, data]);
    console.log(data.user, data.message);
})
socket.on('leave', (data) => {
    setMessages([...messages, data]);
    console.log(data.user, data.message);
})

return () => {
    socket.emit('disconnect');
    socket.off();
    
}
}, [])

useEffect(() => {
    socket.on('sendmessage', (data) => {
        setMessages([...messages, data]);
        console.log(data.user, data.message, data.id);
    })
    return () => {
        socket.off();  
    }
}, [messages])

    return (
        <div className="chatPage">
            <div className="chatContainer">
                <div className="chatHeader">
                    
                   < a href="/"> <h5>back</h5></a>
                </div>
                    <ReactScrollToBottom className="chatBox">
                    {/* {messages.map((item, i) => <Message user={item.id === id ? '' : item.user} message={item.message} classs={item.id === id?'right':'left'} />)} */}
                    {messages.map((item, i) => <Message user={item.id === id ? '' : item.user} message={item.message} classs={item.id === id?'right':'left'} />)}
                    </ReactScrollToBottom>
                <div className="inputBox">
                    <input onKeyPress={(event) =>event.key === "Enter" ? send() : null} type="text" placeholder="Type a message" id="chatInput" />
                    <button onClick={send} id="sendButton">Send</button>
                </div>
                        </div>
            
        </div>
    )
}


export default Chat;


